import { Component, OnInit, Input, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgRedux } from '@angular-redux/store';

import { MenuItemNode } from '../../../../../interfaces/menuItem.interface';
import { AppState, UserState } from '../../../../../interfaces/store.interface';
import { UserProfile } from '../../../../../interfaces/user.interface';
import { ILocalizedString } from '../../../../../interfaces/LocalizedString.interface';

import { CONFIG } from '../../../../shared/config/config.const';
import { getLocalizedText } from '../../../helpers/localization.helper';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent implements OnInit {

    @Input() menuData: MenuItemNode;
    @Input() isInlineNavLink = false;
    @Input() isMobile = false;
    @Input() level = -1;

    userProfile: UserProfile;

    infoToggled = false;

    userProfileSubscription = Subscription.EMPTY;

    constructor(
        private ngRedux: NgRedux<AppState>
    ) { }

    ngOnInit(): void {
        this.userProfileSubscription = this.ngRedux.select<UserState>(['user'])
            .subscribe((userState: UserState) => {

                if (userState.isReady && userState.isLoggedIn && userState.profile) {
                    this.userProfile = userState.profile.payload;
                } else {
                    this.userProfile = null;
                }
            });
    }

    toggleSubMenu() {
        this.menuData._isOpen = !this.menuData._isOpen;
        this.toggleSubMenuDeeply(this.menuData.children);
    }

    localizeCmsMenuText(menuText: ILocalizedString[]) {
        return getLocalizedText(menuText, this.userProfile.culture);
    }

    toggleInfo() {
        this.infoToggled = !this.infoToggled;
    }

    private toggleSubMenuDeeply(nodes: MenuItemNode[]) {
        nodes.forEach((node) => {
            if (node.children && node.children.length > 0) {
                node._isOpen = false;
                this.toggleSubMenuDeeply(node.children);
            }
        });
    }
}
